const API_URL = 'https://www.thecocktaildb.com/api/json/v1/1/';
const IMAGE_URL = 'https://www.thecocktaildb.com/images/ingredients/';
const SMALL_IMAGE = '-Small.png';
const MEDIUM_IMAGE = '-Medium.png';
const LARGE_IMAGE = '.png';

export { API_URL, IMAGE_URL, SMALL_IMAGE, MEDIUM_IMAGE, LARGE_IMAGE };